/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ETypeCertificate } from "../types/ETypeCertificate.ts";

/**
 * @description 0 = MonographAdvise | 1 = MonographBoardMember | 2 = MonographDefense | 3 = FinishCourse | 4 = Teach | 5 = Monitoring |
 */
export const eTypeCertificateSchema = z
  .union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
  ])
  .describe(
    "0 = MonographAdvise | 1 = MonographBoardMember | 2 = MonographDefense | 3 = FinishCourse | 4 = Teach | 5 = Monitoring | ",
  ) as unknown as ToZod<ETypeCertificate>;
